import { render, staticRenderFns } from "./Game_memory_span.vue?vue&type=template&id=7646fffa&style=true"
import script from "./Game_memory_span.vue?vue&type=script&lang=js"
export * from "./Game_memory_span.vue?vue&type=script&lang=js"
import style0 from "./Game_memory_span.vue?vue&type=style&index=0&id=7646fffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports